import React from "react";
import Title from "../common/Title";
import California from "../../assets/img/trip-fourth-img.webp";
import PrimaryBtn from "../common/PrimaryBtn";
import placeOne from "../../assets/img/trip-second-img.webp"
import placeTwo from "../../assets/img/trip-third-img.webp"
import placeThree from "../../assets/img/trip-first-img.webp"

const TripPicksForYou = () => {
  return (
    <div className="max-w-[1176px] mx-auto px-5 pb-[130px] max-lg:pb-16">
      <Title
        text={"Featured Trip Picks for You"}
        myClass={"text-center pb-[50px] max-lg:pb-10"}
      />
      <div className="flex gap-6 max-md:gap-4 max-md:flex-wrap max-md:justify-center">
        <div className="p-4 border border-black/10 rounded-[12px] max-w-max max-md:max-w-full">
          <img
            src={California}
            alt="california"
            className="rounded-[12px] w-[332px] h-[266px]"
          />
          <h5 className="text-[#010101] leading-[100%] text-[34px] max-lg:text-2xl font-medium max-w-[332px] pt-[18px] pb-5 max-lg:py-3">
            Kayaking in Baja California
          </h5>
          <p className="font-medium text-2xl max-lg:text-lg text-[#363636] leading-[100%]">
            From $620
          </p>
          <p className="pt-4 max-md:pt-3 leading-[100%] text-[#363636]">
            Paddle throught, syunning coastal waters.
          </p>
          <PrimaryBtn
            text={"View-details"}
            myClass={"mt-10 max-md:mt-8 w-full !py-3"}
          />
        </div>
        <div className="max-w-[752px] mx-auto grid gap-6 max-lg:gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-lg:gap-4">
            <img
              src={placeOne}
              alt="Left Top"
              className="w-full h-[329px] max-xl:h-[350px] max-md:h-[250px] object-cover rounded-xl"
            />
            <img
              src={placeTwo}
              alt="Right Top"
              className="w-full h-[329px] max-xl:h-[350px] max-md:h-[250px] object-cover rounded-xl"
            />
          </div>
          <div>
            <img
              src={placeThree}
              alt="Bottom Full Width"
              className="w-full h-[198px] max-xl:h-[205px] max-md:h-[250px] object-cover rounded-[12px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripPicksForYou;
